import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRightIcon } from 'lucide-react';
import { closingLines, productShortName } from '../data/offer';
export function ClosingSection() {
  return <section className="bg-navy-800 py-16 sm:py-20" aria-labelledby="closing-title" data-id="element-55" data-mp="12t3stjme3hm5">
      <div className="mx-auto max-w-4xl px-4" data-id="element-56" data-mp="xu0oy2i5bhfr">
        <div className="text-center" data-id="element-57" data-mp="xs7fygk28l4l">
          <h2 id="closing-title" className="text-balance text-3xl font-extrabold leading-tight text-white sm:text-4xl" data-id="element-58" data-mp="1cr1ebzcv70b2">
            El próximo lunes puedes seguir improvisando...
          </h2>
          <p className="metal-text mt-4 font-serif text-2xl font-extrabold tracking-tight sm:text-3xl" data-id="element-59" data-mp="1ljbq3l3erduf">
            O puedes entrar al aula con todo listo desde hoy.
          </p>
        </div>

        <ul className="mx-auto mt-10 grid max-w-3xl gap-3" data-id="element-60" data-mp="1hk419on4zbia">
          {closingLines.map((line, index) => <motion.li key={line} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.28,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex items-center gap-3 rounded-lg border-l-4 border-silver-300 bg-navy-950 px-4 py-3 text-sm font-semibold text-white" data-id="element-61" data-mp="1qifvs1r4itg0" data-mpi={index}>
              <ChevronRightIcon className="h-4 w-4 shrink-0 text-silver-300" aria-hidden="true" data-id="element-62" data-mp="2gd6gxb7wl82b" />
              {line}
            </motion.li>)}
        </ul>

        <div className="mx-auto mt-10 max-w-2xl text-center" data-id="element-63" data-mp="2qa1i61vk9mka">
          <p className="leading-relaxed text-silver-200" data-id="element-64" data-mp="2q8gijxue3dfk">
            El {productShortName} no te convierte en mejor docente. Vos ya eres un buen docente.
          </p>
          <p className="mt-3 text-lg font-bold text-white" data-id="element-65" data-mp="2zz2y5s23w3y9">
            Lo que hace el megapack es darte el tiempo y las herramientas para que eso se note en cada clase.
          </p>
        </div>
      </div>
    </section>;
}